(function () {
  const ENDPOINT = "https://hp-vvs-meta-ads-analyst.vercel.app/api/website/events";
  const ATTRIBUTION_STORAGE_KEY = "hp_attribution_v1";
  const ATTRIBUTION_COOKIE_NAME = "hp_attr";
  const SCROLL_THRESHOLDS = [25, 50, 75, 90];
  const ENGAGED_SECONDS = [30, 60, 120];
  const MAX_LABEL_LENGTH = 90;
  const MOBILE_NAV_BREAKPOINT = 1179;
  const sentKeys = new Set();
  const firedScroll = new Set();
  const firedEngaged = new Set();
  const startedAt = Date.now();
  const visitorId = ensureId("hp_vid", 395);
  const sessionId = ensureId("hp_sid", 1);

  function randomId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return `${prefix}-${window.crypto.randomUUID()}`;
    }
    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  }

  function readCookie(name) {
    const prefix = `${name}=`;
    const match = document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(prefix));
    if (!match) return "";
    try {
      return decodeURIComponent(match.slice(prefix.length));
    } catch (error) {
      return match.slice(prefix.length);
    }
  }

  function writeCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) || "" : "";
    } catch (error) {
      return "";
    }
  }

  function safeStorageSet(key, value) {
    try {
      if (window.localStorage) window.localStorage.setItem(key, value);
    } catch (error) {}
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function ensureId(name, days) {
    const existing = readCookie(name);
    if (existing) return existing;
    const id = randomId(name);
    writeCookie(name, id, days);
    return id;
  }

  function pagePath() {
    return window.location.pathname || "/";
  }

  function pageGroup(path) {
    const normalized = (path || pagePath()).toLowerCase();
    if (normalized === "/") return "home";
    if (normalized.includes("/book-an-appointment")) return "booking";
    if (normalized.includes("/custom-jewelry-design") || normalized.includes("/jewelry-design")) return "custom_design";
    if (normalized.includes("/about-us") || normalized.includes("/our-story")) return "our_story";
    if (normalized.includes("/our_store") || normalized.includes("/visit")) return "visit";
    if (normalized.includes("/collections/engagement-ring")) return "engagement";
    if (normalized.includes("/collections/high-jewelry") || normalized.includes("/collections/fine-jewelry")) return "fine_jewelry";
    if (normalized.includes("/products/")) return "product";
    if (normalized.includes("/collections/")) return "collection";
    if (normalized.includes("/search")) return "search";
    return "other";
  }

  function eventType(eventName) {
    if (eventName === "PageView" || eventName === "ViewContent") return "page";
    if (eventName === "Search") return "search";
    if (eventName.indexOf("Click") !== -1) return "click";
    if (eventName.indexOf("Booking") === 0) return "booking";
    if (eventName === "Schedule") return "conversion";
    if (eventName === "ScrollDepth" || eventName.indexOf("Engaged") === 0) return "engagement";
    return "custom";
  }

  function utmParams() {
    const params = new URLSearchParams(window.location.search);
    const firstParam = function (names) {
      for (let index = 0; index < names.length; index += 1) {
        const value = params.get(names[index]);
        if (value) return value;
      }
      return undefined;
    };

    return cleanObject({
      ad: firstParam(["utm_ad", "ad"]),
      adId: firstParam(["utm_ad_id", "ad_id"]),
      adset: firstParam(["utm_adset", "adset"]),
      adsetId: firstParam(["utm_adset_id", "adset_id"]),
      campaign: firstParam(["utm_campaign", "campaign"]),
      campaignId: firstParam(["utm_campaign_id", "campaign_id"]),
      content: firstParam(["utm_content", "content"]),
      creative: firstParam(["utm_creative", "creative"]),
      fbclid: params.get("fbclid") || undefined,
      gclid: params.get("gclid") || undefined,
      id: firstParam(["utm_id", "id"]),
      medium: params.get("utm_medium") || undefined,
      msclkid: params.get("msclkid") || undefined,
      placement: firstParam(["utm_placement", "placement"]),
      source: params.get("utm_source") || undefined,
      term: params.get("utm_term") || undefined,
      ttclid: params.get("ttclid") || undefined,
    });
  }

  function cleanObject(value) {
    return Object.fromEntries(
      Object.entries(value || {}).filter((entry) => entry[1] !== undefined && entry[1] !== ""),
    );
  }

  function hasValues(value) {
    return Object.values(value || {}).some((item) => item !== undefined && item !== "");
  }

  function hasAttributionSignal(utm, referrer) {
    const source = String(utm.source || "").toLowerCase();
    const medium = String(utm.medium || "").toLowerCase();
    const ref = String(referrer || "").toLowerCase();
    return Boolean(
      hasValues(utm) ||
        source === "fb" ||
        source === "ig" ||
        source.includes("facebook") ||
        source.includes("instagram") ||
        source.includes("meta") ||
        medium.includes("paid") ||
        medium === "cpc" ||
        medium === "ppc" ||
        ref.includes("facebook.com") ||
        ref.includes("instagram.com"),
    );
  }

  function storedAttribution() {
    return parseJson(safeStorageGet(ATTRIBUTION_STORAGE_KEY)) || parseJson(readCookie(ATTRIBUTION_COOKIE_NAME));
  }

  function persistAttribution(attribution) {
    const serialized = JSON.stringify(attribution);
    safeStorageSet(ATTRIBUTION_STORAGE_KEY, serialized);
    if (serialized.length < 3000) writeCookie(ATTRIBUTION_COOKIE_NAME, serialized, 90);
  }

  function captureAttribution() {
    const utm = utmParams();
    // _fbc is owned by Meta's Pixel + Parameter Builder (snippets/hp-meta-pixel.liquid); never write it here.
    const fbc = readCookie("_fbc");
    const fbp = readCookie("_fbp");
    const referrer = document.referrer || undefined;
    const existing = storedAttribution();

    if (!hasAttributionSignal(utm, referrer)) return existing;

    if (existing && existing.landingPageUrl) {
      const enriched = cleanObject({
        ...existing,
        // Newest click wins (Meta: "store and send the most recent value"); first landing stays in utm/landingPageUrl.
        fbc: fbc || existing.fbc || undefined,
        fbp: existing.fbp || fbp || undefined,
        utm: existing.utm || (hasValues(utm) ? utm : undefined),
      });
      if (JSON.stringify(enriched) !== JSON.stringify(existing)) persistAttribution(enriched);
      return enriched;
    }

    const attribution = cleanObject({
      capturedAt: new Date().toISOString(),
      fbc: fbc || undefined,
      fbp: fbp || undefined,
      landingPagePath: pagePath(),
      landingPageUrl: window.location.href,
      referrer,
      utm: hasValues(utm) ? utm : undefined,
    });
    persistAttribution(attribution);
    return attribution;
  }

  function context() {
    const attribution = captureAttribution();
    const currentUtm = utmParams();
    const inheritedUtm = attribution && attribution.utm;
    return {
      attribution: attribution || undefined,
      fbc: readCookie("_fbc") || (attribution && attribution.fbc) || undefined,
      fbp: readCookie("_fbp") || (attribution && attribution.fbp) || undefined,
      pageGroup: pageGroup(pagePath()),
      pagePath: pagePath(),
      pageTitle: document.title,
      pageUrl: window.location.href,
      referrer: document.referrer || undefined,
      sessionId,
      userAgent: window.navigator.userAgent,
      utm: hasValues(currentUtm) ? currentUtm : inheritedUtm || {},
      visitorId,
    };
  }

  function track(eventName, properties, options) {
    const opts = options || {};
    const key = opts.onceKey;
    if (key && sentKeys.has(key)) return;
    if (key) sentKeys.add(key);

    const payload = cleanObject({
      ...context(),
      eventId: opts.eventId || randomId("hp_evt"),
      eventName,
      eventType: opts.eventType || eventType(eventName),
      occurredAt: new Date().toISOString(),
      properties: cleanObject(properties || {}),
    });

    if (window.dataLayer && typeof window.dataLayer.push === "function") {
      window.dataLayer.push({
        event: `hp_${eventName}`,
        hp_event_name: eventName,
        hp_page_group: payload.pageGroup,
        hp_session_id: sessionId,
      });
    }

    send(payload);
  }

  function send(payload) {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(ENDPOINT, blob)) return;
    }

    fetch(ENDPOINT, {
      body,
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      method: "POST",
    }).catch(function () {});
  }

  function textLabel(element) {
    const label =
      element.getAttribute("data-hp-track-label") ||
      element.getAttribute("aria-label") ||
      element.textContent ||
      element.value ||
      "";
    return label.trim().replace(/\s+/g, " ").slice(0, MAX_LABEL_LENGTH);
  }

  function isImportantClick(element) {
    if (!element) return false;
    if (element.hasAttribute("data-hp-track")) return true;
    if (element.matches(".nav-link, .nav-cta, .nav-mobile-toggle, .hp-mobile-nav-link, .brand-mark, .visit-card, .time-slot, .cal-day, .summary-card__cta, .mobile-summary__cta, .product-card, .product-tile")) return true;
    if (element.matches('a[href^="tel:"], a[href^="mailto:"], a[href*="maps"], a[href*="/pages/book-an-appointment"], a[href*="/collections/"], a[href*="/products/"]')) return true;
    return false;
  }

  function bindClicks() {
    document.addEventListener("click", function (event) {
      const element = event.target && event.target.closest("a, button, [data-hp-track]");
      if (!isImportantClick(element)) return;
      track("ImportantClick", {
        href: element.href || undefined,
        id: element.id || undefined,
        label: textLabel(element),
        target: element.tagName ? element.tagName.toLowerCase() : undefined,
      });
    }, true);
  }

  function bindSearches() {
    document.addEventListener("submit", function (event) {
      const form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/search"], form[role="search"]')) return;
      const input = form.querySelector('input[type="search"], input[name="q"]');
      const term = input && input.value ? input.value.trim() : "";
      track("Search", {
        queryLength: term.length,
      });
    }, true);

    if (pagePath().includes("/search")) {
      const query = new URLSearchParams(window.location.search).get("q") || "";
      track("Search", { queryLength: query.length }, { onceKey: `search-page:${query}` });
    }
  }

  function bindBookingSteps() {
    document.addEventListener("click", function (event) {
      const visitCard = event.target && event.target.closest(".visit-card");
      if (visitCard) {
        track("BookingVisitSelected", {
          duration: visitCard.getAttribute("data-duration") || undefined,
          visit: visitCard.getAttribute("data-visit") || textLabel(visitCard),
        });
      }

      const dateButton = event.target && event.target.closest(".cal-day:not(.is-disabled)");
      if (dateButton && !dateButton.disabled) {
        track("BookingDateSelected", { label: textLabel(dateButton) });
      }

      const timeButton = event.target && event.target.closest(".time-slot");
      if (timeButton) {
        track("BookingTimeSelected", { label: textLabel(timeButton) });
      }

      const submit = event.target && event.target.closest("#confirm-btn, #mobile-confirm-btn");
      if (submit) {
        track("BookingSubmitAttempt", { label: textLabel(submit) });
      }
    }, true);

    document.addEventListener("focusin", function (event) {
      const element = event.target;
      if (!element || !element.closest || !element.closest(".contact-grid")) return;
      if (!element.matches("input, textarea, select")) return;
      track("BookingContactStarted", {}, { onceKey: "booking-contact-started" });
    }, true);
  }

  function bindScrollDepth() {
    function handleScroll() {
      const doc = document.documentElement;
      const scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
      const depth = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
      SCROLL_THRESHOLDS.forEach(function (threshold) {
        if (depth >= threshold && !firedScroll.has(threshold)) {
          firedScroll.add(threshold);
          track("ScrollDepth", { depth: threshold }, { onceKey: `scroll:${threshold}` });
        }
      });
    }

    window.addEventListener("scroll", throttle(handleScroll, 400), { passive: true });
    handleScroll();
  }

  function bindEngagedTime() {
    ENGAGED_SECONDS.forEach(function (seconds) {
      window.setTimeout(function () {
        if (document.visibilityState !== "visible" || firedEngaged.has(seconds)) return;
        firedEngaged.add(seconds);
        track(`Engaged${seconds}Seconds`, {
          seconds,
          totalSeconds: Math.round((Date.now() - startedAt) / 1000),
        }, { onceKey: `engaged:${seconds}` });
      }, seconds * 1000);
    });
  }

  function isMobileNavViewport() {
    return window.matchMedia && window.matchMedia(`(max-width: ${MOBILE_NAV_BREAKPOINT}px)`).matches;
  }

  function ensureMobileNavStyle() {
    if (document.getElementById("hp-mobile-nav-style")) return;
    const style = document.createElement("style");
    style.id = "hp-mobile-nav-style";
    style.textContent = `
@media (max-width: ${MOBILE_NAV_BREAKPOINT}px) {
  body.hp-mobile-nav-open { overflow: hidden; }
  .nav { z-index: 90; }
  .nav-mobile-toggle {
    min-height: 44px;
    cursor: pointer;
    outline-offset: 4px;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
  .nav-mobile-toggle:focus-visible {
    color: var(--ink-primary, #2A2725);
    text-decoration: underline;
    text-decoration-color: var(--accent, #E91D79);
    text-underline-offset: 5px;
  }
  .hp-mobile-nav-generated {
    appearance: none;
    background: transparent;
    border: 0;
    color: var(--ink-body, #4A4540);
    display: flex;
    flex: 1;
    font-family: var(--font-body, Georgia, serif);
    font-size: 10.5px;
    letter-spacing: 0.16em;
    line-height: 1;
    padding: 0;
    text-align: left;
    text-transform: uppercase;
  }
  .hp-mobile-nav-panel {
    background-color: var(--bg-foundation, #F7F1EB);
    background-image: var(--hp-toile-url, none);
    background-size: 560px auto;
    background-repeat: repeat;
    border-top: 1px solid var(--rule, #D4CFC4);
    bottom: 0;
    display: none;
    left: 0;
    overflow: auto;
    position: fixed;
    right: 0;
    top: var(--hp-mobile-nav-top, 72px);
    z-index: 120;
    isolation: isolate;
    -webkit-overflow-scrolling: touch;
  }
  .hp-mobile-nav-panel::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(247, 241, 235, 0.93);
    pointer-events: none;
    z-index: -1;
  }
  .nav.is-mobile-open .hp-mobile-nav-panel { display: block; }
  .hp-mobile-nav-panel__inner {
    padding: 8px 20px calc(32px + env(safe-area-inset-bottom));
  }
  .hp-mobile-nav-link {
    align-items: center;
    border-bottom: 1px solid var(--rule, #D4CFC4);
    color: var(--ink-primary, #2A2725);
    display: flex;
    font-family: var(--font-body, Georgia, serif);
    font-size: 16px;
    justify-content: space-between;
    letter-spacing: 0.16em;
    line-height: 1.25;
    min-height: 56px;
    padding: 16px 0;
    text-transform: uppercase;
  }
  .hp-mobile-nav-link::after {
    background: var(--rule, #D4CFC4);
    content: "";
    flex: 0 0 auto;
    height: 1px;
    margin-left: 18px;
    width: 24px;
  }
  .hp-mobile-nav-link.is-active {
    border-bottom-color: var(--accent, #E91D79);
    color: var(--ink-primary, #2A2725);
  }
  .hp-mobile-nav-link:focus-visible {
    outline: 2px solid var(--accent, #E91D79);
    outline-offset: 4px;
  }
}
@media (min-width: ${MOBILE_NAV_BREAKPOINT + 1}px) {
  .hp-mobile-nav-generated,
  .hp-mobile-nav-panel { display: none !important; }
}
`;
    document.head.appendChild(style);
  }

  function collectMobileNavLinks(nav) {
    const seen = new Set();
    const links = [];
    nav.querySelectorAll(".nav-links a, .nav-cta").forEach(function (source) {
      const href = source.getAttribute("href");
      const label = textLabel(source);
      if (!href || !label) return;
      const key = `${href}|${label.toLowerCase()}`;
      if (seen.has(key)) return;
      seen.add(key);
      links.push({
        active: source.classList.contains("is-active"),
        href,
        label,
      });
    });
    return links;
  }

  function ensureMobileNavToggle(nav, navInner) {
    let toggle = nav.querySelector(".nav-mobile-toggle");
    if (toggle) return toggle;
    toggle = document.createElement("button");
    toggle.className = "nav-mobile-toggle hp-mobile-nav-generated";
    toggle.textContent = "Menu";
    toggle.type = "button";
    const brand = navInner.querySelector(".brand-mark");
    navInner.insertBefore(toggle, brand || navInner.firstChild);
    return toggle;
  }

  function updateMobileNavTop(nav) {
    const bottom = Math.max(0, Math.round(nav.getBoundingClientRect().bottom));
    nav.style.setProperty("--hp-mobile-nav-top", `${bottom}px`);
  }

  function bindMobileNav() {
    const navs = Array.from(document.querySelectorAll(".nav"));
    if (!navs.length) return;
    ensureMobileNavStyle();

    navs.forEach(function (nav, index) {
      if (nav.dataset.hpMobileNavBound === "true") return;
      const navInner = nav.querySelector(".nav-inner");
      if (!navInner) return;
      if (nav.querySelector(".nav-mobile-menu .nav-mobile-drawer")) {
        nav.dataset.hpMobileNavBound = "true";
        return;
      }
      const links = collectMobileNavLinks(nav);
      if (!links.length) return;

      const toggle = ensureMobileNavToggle(nav, navInner);
      const originalLabel = textLabel(toggle) || "Menu";
      const panel = document.createElement("div");
      const panelId = `hp-mobile-nav-panel-${index + 1}`;
      const panelInner = document.createElement("div");

      panel.className = "hp-mobile-nav-panel";
      panel.id = panelId;
      panel.setAttribute("aria-hidden", "true");
      panelInner.className = "hp-mobile-nav-panel__inner";

      links.forEach(function (item) {
        const link = document.createElement("a");
        link.className = item.active ? "hp-mobile-nav-link is-active" : "hp-mobile-nav-link";
        link.href = item.href;
        link.textContent = item.label;
        panelInner.appendChild(link);
      });

      panel.appendChild(panelInner);
      nav.appendChild(panel);

      toggle.setAttribute("aria-controls", panelId);
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open navigation menu");
      if (toggle.tagName.toLowerCase() !== "button") {
        toggle.setAttribute("role", "button");
        toggle.setAttribute("tabindex", "0");
      }

      function closeNav() {
        nav.classList.remove("is-mobile-open");
        panel.setAttribute("aria-hidden", "true");
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-label", "Open navigation menu");
        toggle.textContent = originalLabel;
        if (!document.querySelector(".nav.is-mobile-open")) {
          document.body.classList.remove("hp-mobile-nav-open");
        }
      }

      function openNav() {
        if (!isMobileNavViewport()) return;
        document.querySelectorAll(".nav.is-mobile-open").forEach(function (openNavElement) {
          if (openNavElement !== nav) openNavElement.classList.remove("is-mobile-open");
        });
        updateMobileNavTop(nav);
        nav.classList.add("is-mobile-open");
        document.body.classList.add("hp-mobile-nav-open");
        panel.setAttribute("aria-hidden", "false");
        toggle.setAttribute("aria-expanded", "true");
        toggle.setAttribute("aria-label", "Close navigation menu");
        toggle.textContent = "Close";
      }

      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        if (nav.classList.contains("is-mobile-open")) closeNav();
        else openNav();
      });

      toggle.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        if (nav.classList.contains("is-mobile-open")) closeNav();
        else openNav();
      });

      panel.addEventListener("click", function (event) {
        if (event.target && event.target.closest("a")) closeNav();
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeNav();
      });

      window.addEventListener("resize", throttle(function () {
        if (!isMobileNavViewport()) closeNav();
        else if (nav.classList.contains("is-mobile-open")) updateMobileNavTop(nav);
      }, 150), { passive: true });

      window.addEventListener("scroll", throttle(function () {
        if (nav.classList.contains("is-mobile-open")) updateMobileNavTop(nav);
      }, 150), { passive: true });

      nav.dataset.hpMobileNavBound = "true";
    });
  }

  function throttle(fn, wait) {
    let last = 0;
    let timer = null;
    return function () {
      const now = Date.now();
      const remaining = wait - (now - last);
      if (remaining <= 0) {
        last = now;
        fn();
      } else if (!timer) {
        timer = window.setTimeout(function () {
          last = Date.now();
          timer = null;
          fn();
        }, remaining);
      }
    };
  }

  function init() {
    track("PageView", {}, { onceKey: `pageview:${window.location.href}` });
    if (["booking", "custom_design", "our_story", "visit", "engagement", "fine_jewelry", "product"].includes(pageGroup(pagePath()))) {
      track("ViewContent", {}, { onceKey: `viewcontent:${window.location.href}` });
    }
    bindClicks();
    bindSearches();
    bindBookingSteps();
    bindMobileNav();
    bindScrollDepth();
    bindEngagedTime();
  }

  const api = { context, pageGroup, track };
  try {
    window.HPAnalytics = api;
  } catch (error) {}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
